<template>
  <div>
    <change-pwd type="email" @findSuccess="findSuccess" @changeCom="changeCurrentCom"></change-pwd>
  </div>
</template>
<script>
import ChangePwd from './ChangePwd.vue'
export default {
  name: 'WorkspaceJsonFindByEmail',
  components: { ChangePwd },
  methods: {
    findSuccess(res) {
      this.$emit('findSuccess', res)
    },
    changeCurrentCom(com, loginCom = true) {
      this.$emit('changeCom', com, loginCom)
    },
  },
}
</script>
